/**
 * "MOSTRAR O MATERIAL DE TESTE NESTE APARELHO" (23/10/2026, item 5). A conta de demonstração esconde das listas os
 * simulados e as turmas "ZZ TESTE …" — a regra e as cláusulas são do servidor (`backend/src/services/materialDeTeste.ts`).
 * Aqui mora só a escolha, que viaja em todo pedido como `?materialDeTeste=1` (o `if` é o interceptador de `api.ts`).
 *
 * Fica guardada NESTE APARELHO (é o aparelho de quem testa, e não o do revisor): ligada, o material aparece de novo.
 */
const CHAVE = 'material-de-teste:mostrar';

export function mostrarMaterialDeTeste(): boolean {
  try { return localStorage.getItem(CHAVE) === '1'; } catch { return false; }
}
export function ligarMaterialDeTeste(ligado: boolean): void {
  try { if (ligado) localStorage.setItem(CHAVE, '1'); else localStorage.removeItem(CHAVE); } catch { /* sem armazenamento: fica escondido */ }
}
